// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
export function Controller($scope, $state) {
}



// WEBPACK FOOTER //
// ./src/portal/states/public/downloads/downloads.controller.js